/*
 app dependencies
 - var body

 lib dependencies
*/

const scOptionSearch = (function($)
{
    //private
    let _instances = [],
        _currentSearch;

	//module functions
    function init(parent=document)
    {
        const optionSearchInputs = parent.querySelectorAll('.js-option-search');
        Array.from(optionSearchInputs).forEach(function(input)
        {
            initField(input);
        });
    }

	function initField(input)
	{
        if (input.classList.contains('js-option-search--initiated')) return;

        input.dataset.optionSearchInstance = _instances.length;

        const optionsContainer = document.querySelector(input.dataset.optionsContainer);
        const options = optionsContainer.querySelectorAll('.js-option-search__opt');
        const db = [];
        Array.from(options).forEach(function(opt)
        {
            let match;
            if (opt.dataset.match) match = removeDiacritics(opt.dataset.match);
            else match = removeDiacritics(opt.querySelector('label').textContent);
            
            db.push({
                match: match,
                el: opt
            })
        });

        _instances.push({
            id: _instances.length,
            optionsContainer,
            options,
            db
        });

        input.addEventListener('keyup', function(e)
        {
            _currentSearch = this.value.toUpperCase();

            const inst = _get(this);

            //reset
            Array.from(inst.options).forEach(function(el)
            {
                el.classList.remove('hide');
            });

            //collect items to hide via db
            const toHide = inst.db.filter(function(dbEntry)
            {
                //skip sticky elements
                if (dbEntry.el.classList.contains('js-option-search__opt--sticky')) return false;
                //return elements that DO NOT match: we'll be adding a class to hide them
                return dbEntry.match.toUpperCase().indexOf(_currentSearch) < 0;
            });
            //hide items
            toHide.forEach(function(result)
            {
                result.el.classList.add('hide');
            });

            //hide items via dom matching (SLOWER)
            /*Array.from(inst.options).forEach(function(el)
            {
                if (removeDiacritics(el.querySelector('label').textContent).toUpperCase().indexOf(_currentSearch) < 0)
                {
                    el.classList.add('hide');
                }
            });*/
        });

        input.classList.add('js-option-search--initiated');
	}

    //retrieve instance
    function _get(input)
    {
        return _instances[input.dataset.optionSearchInstance];
    }


	//reveal public vars and functions
	return {
		//vars

		//functions
		init,
        initField
	};

})(jQuery);
